module.exports = __webpack_public_path__ + "graphics/upgrade-banner-left.ckh.1e6d9f61391b003ec7617528343b5664.svg";